'use strict';

import React, { PropTypes } from 'react';
import BackColorMixin from '../mixins/BackColorMixin';
import ClassNameMixin from '../mixins/ClassNameMixin';
import StampLink from '../atoms/StampLink';
import UserLink from '../atoms/UserLink';
import UserImage from '../atoms/UserImage';
import Icon from '../atoms/Icon';
import SubmitStampControl from '../molecules/SubmitStampControl';
import ZineLink from '../atoms/ZineLink';
import FontTest from '../atoms/FontTest';
import UserStore from '../stores/UserStore';
import PureRenderMixin from '../mixins/PureRenderMixin';
import createStoreMixin from '../mixins/createStoreMixin';
import getZineThumbnail from '../utils/getZineThumbnail';
import getThumbnailUrl from '../utils/getThumbnailUrl';
import dangerouslyStripHTML from '../utils/dangerouslyStripHTML';
import isEmptyishHTML from '../utils/isEmptyishHTML';
import StampRichThumbnail from '../molecules/StampRichThumbnail';
import StampThumbnail from '../molecules/StampThumbnail';
import StampStatus from '../constants/StampStatus';

require('./StampItem.less');

var StampItem = React.createClass({
  mixins: [
    createStoreMixin(UserStore),
    BackColorMixin, ClassNameMixin,
    PureRenderMixin
  ],

  propTypes: {
    stamp: PropTypes.object.isRequired,
    targetZine: PropTypes.object,
    size: PropTypes.oneOf(['small', 'medium']).isRequired,
    showSubmit: PropTypes.bool,
    showLikes: PropTypes.bool,
    isTrending: PropTypes.bool.isRequired,
    primaryZine: PropTypes.object,
    routeName: PropTypes.string,
    routeParams: PropTypes.object,
    allowEmptyThumbnail: PropTypes.bool
  },

  className: 'StampItem',

  getDefaultProps() {
    return {
      size: 'medium',
      type: 'stamp',
      isTrending: false,
      showLikes: true
    };
  },

  getStateFromStores(props) {
    return {
      user: UserStore.get(props.stamp.user)
    };
  },

  getCSSModifiers() {
    return [
      this.props.size,
      this.hasDescription() && 'hasDescription',
      this.props.showSubmit && 'showSubmit',
      this.props.primaryZine && 'hasZine',
      this.props.stamp.thumbnail && 'hasThumbnail',
      this.props.stamp.isLiked && 'isLiked'
    ];
  },

  getZineThumbnailStyle(zine) {
    const devicePixelRatio = (typeof window !== 'undefined') ? window.devicePixelRatio : 1;

    var image = getZineThumbnail(zine),
        size = 3 * 16 * Math.round(devicePixelRatio),
        thumbnailUrl;

    thumbnailUrl = getThumbnailUrl(image, {
      mode: 'scale_crop',
      width: size,
      height: size
    });

    return {
      backgroundImage: 'url(' + thumbnailUrl + ')'
    };
  },

  hasDescription() {
    return !isEmptyishHTML(this.props.stamp.description);
  },

  render() {
    const { stamp, size, showSubmit, primaryZine, isTrending } = this.props;
    const { user } = this.state;
    const isSmall = size === 'small';
    const isUnlisted = stamp.status === StampStatus.UNLISTED;

    return (
      <div className={this.getClassName()}>
        {isTrending &&
          <span className='StampItem-badge StampItem-trending' title='Trending Stamp'>
            <Icon name='trending'
                  mode='stroke'
                  size='xxsmall'
                  margin='right' />
            Trending
          </span>
        }
        {isUnlisted &&
          <span className='StampItem-badge StampItem-secret'
                title='This Stamp is only visible to those who have the direct link to it.'>
            <Icon name='eyeCrossed'
                  mode='fill'
                  size='xsmall'
                  margin='right' />
            Secret
          </span>
        }

        <StampLink stamp={stamp}
                   className='StampItem-body'
                   routeName={this.props.routeName}
                   routeParams={this.props.routeParams}
                   underline='never'>

          <StampThumbnail thumbnail={stamp.thumbnail}
                          allowEmpty={this.props.allowEmptyThumbnail} />

          <div className='StampItem-info'>
            <div className='StampItem-titleAndDescription'>
              <div className='StampItem-title'>
                {stamp.title}
              </div>

              {this.hasDescription() &&
                <FontTest family='minion-pro-condensed'
                          test={stamp.description}>
                  <div className='StampItem-subtitle'>
                    {dangerouslyStripHTML(stamp.description)}
                  </div>
                </FontTest>
              }
            </div>

            {stamp.richThumbnail &&
              <StampRichThumbnail {...stamp.richThumbnail}
                                  iconSize={isSmall ? 'xsmall' : 'xsmall'} />
            }
          </div>
        </StampLink>

        <div className='StampItem-footer'>
          {!showSubmit &&
            <div className='StampItem-meta'>
              <div className='StampItem-avatars'>
                {!isSmall && primaryZine &&
                  <ZineLink zine={primaryZine}>
                    <div className='StampItem-zineAvatar'
                         style={this.getZineThumbnailStyle(primaryZine)} />
                  </ZineLink>
                }

                {!isSmall && primaryZine &&
                  <UserLink user={user}>
                    <UserImage className='StampItem-userAvatar'
                               user={user}
                               size='xsmall' />
                  </UserLink>
                }

                {!isSmall && !primaryZine &&
                  <UserLink user={user}>
                    <UserImage className='StampItem-userAvatar'
                               user={user}
                               size='small' />
                  </UserLink>
                }

                {isSmall && !showSubmit &&
                  <UserLink user={user}>
                    <UserImage className='StampItem-userAvatar'
                               user={user}
                               size='xsmall' />
                  </UserLink>
                }
              </div>

              <div className='StampItem-zineAndUser'>
                {!isSmall && primaryZine &&
                  <div className='StampItem-zine'>
                    in <ZineLink className='StampItem-zineTitle'
                                 zine={primaryZine}
                                 underline='hover'
                                 bold />
                  </div>
                }
                <div className='StampItem-user'>
                  by <UserLink className='StampItem-userName'
                               user={user}
                               underline='hover' />
                </div>
              </div>
            </div>
          }

          {this.renderFooterContent()}
        </div>
      </div>
    );
  },

  renderFooterContent() {
    var { stamp, showSubmit, showLikes, targetZine } = this.props;

    if (showSubmit && targetZine) {
      return (
        <div className='StampItem-footerAction'>
          <SubmitStampControl stamp={stamp}
                              zine={targetZine}
                              color='gray' />
        </div>
      );
    }

    if (showLikes) {
      return (
        <div className='StampItem-counters'>
          <Icon className='StampItem-likeIcon'
                name='like'
                size='xsmall' />
          <span>
            {stamp.likeCount}
          </span>
        </div>
      );
    }
  }
});

export default StampItem;



/** WEBPACK FOOTER **
 ** ./organisms/StampItem.jsx
 **/